import React from 'react';
import { faHome, faEnvelope, faMobileScreenButton, faEarthAmericas } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ResumeHeader({config, resume, isCompact = false}) {
    // Handle case where resume might be undefined during initial render or if data is missing
    if (!resume) {
        return (
            <header className="flex items-center justify-between w-full text-sm space-x-10">
                <div className="w-full">
                    <h1 className="font-extrabold text-[2.85rem] tracking-tight text-light-800 leading-none">{config.name}</h1>
                    <h2 className="pt-1 pl-1 pr-24">{config.headline}</h2>
                </div>
            </header>
        );
    }

    const headerMargin = isCompact ? 'mb-2' : 'mb-4';

    return (
        <header className={`flex items-center justify-between w-full text-sm space-x-10 ${headerMargin}`}>
            {/* Profile Information */}
            <div className="w-full">
                <h1 className="font-extrabold text-[2.85rem] tracking-tight text-light-800 leading-none">{resume.name === "" ? config.name : resume.name}</h1>
                <h2 className="pt-1 pl-1 pr-24">{resume.headline !== "" ? resume.headline : config.headline}</h2>
            </div>

            {/* Contact Info */}
            <ul className="w-80">
                {/* Address */}
                <li className="flex items-center space-x-1">
                    <FontAwesomeIcon icon={faHome}/>
                    <p><a className="text-light-700"
                          href={config.addressURL(resume.address !== "" ? resume.address : config.address)}
                          target="_blank"
                          rel="noopener noreferrer">{resume.address !== "" ? resume.address : config.address}</a>
                    </p>
                </li>
                <li className="flex items-center space-x-1">
                    <FontAwesomeIcon icon={faEnvelope}/>
                    <p>{resume.email !== "" ? resume.email : config.email}</p>
                </li>

                <li className="flex items-center space-x-1">
                    <FontAwesomeIcon icon={faMobileScreenButton}/>
                    <p>{resume.phone !== "" ? resume.phone : config.phone}</p>
                </li>

                <li className="flex items-center space-x-1">
                    <FontAwesomeIcon icon={faGithub}/>
                    <p>{config.displayURL(resume.socialMediaUrl?.github !== "" ? resume.socialMediaUrl?.github : config.socialMediaUrl.github)}</p>
                </li>

                <li className="flex items-center space-x-1">
                    <FontAwesomeIcon icon={faEarthAmericas}/>
                    <p>{config.displayURL(resume.website)}</p>
                </li>
            </ul>
        </header>
    )
}

export default ResumeHeader;